import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-numeric-keypad',
  templateUrl: './numeric-keypad.component.html',
  styleUrl: './numeric-keypad.component.scss',
  standalone: false,
})
export class NumericKeypadComponent {
  @Input() fieldName: any;
  @Input() isLoading: boolean = false;
  @Output() eventOnKeyPress: EventEmitter<string> = new EventEmitter<string>();
  @Output() eventOnOk: EventEmitter<unknown> = new EventEmitter();
  @Output() eventOnclear: EventEmitter<unknown> = new EventEmitter();

  keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

  constructor() {}

  ngOnInit() {}
}
